//import Button from "@gigandtake/button";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import Button from "../../../../../design/button";
import { formatDate, hasPermission } from "../../../../../utils/helpers";

type EditActionButtonsProps = {
  handleClose: (() => void) | undefined;
  isValid: boolean;
  dirty: boolean;
  isSubmitting: boolean;
  isDisabled: boolean;
  createdByName?: string;
  createdBy?: number | string;
  createdDate?: string;
};

const EditActionButtons: React.FC<EditActionButtonsProps> = ({
  handleClose,
  isValid,
  dirty,
  isSubmitting,
  isDisabled,
  createdByName = "",
  createdBy,
  createdDate,
}) => {
  const { t } = useTranslation();
  const currentUserId = useSelector((state: any) => state.user?.userData?.id);
  const userRolesWithPermissions = useSelector((state: any) => state.user.userData.userRolesWithPermissions);

  return (
		<Box
			display='flex'
			width='100%'
			justifyContent='space-between'
			alignItems='center'
			flexDirection='row'
		>
      <Box style={{ marginRight: "24px" }}>
        <Typography
            variant="body2"
            sx={{
              fontFamily: "Roboto",
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              color: "#00000099",
            }}
        >
          {createdDate
            ? t("scheduler_created-by-datetime", {
                name: createdByName,
                date: formatDate({
                  dateStr: createdDate ?? "",
                  formatType: "CAPTION_DATE",
                }),
                time: formatDate({
                  dateStr: createdDate ?? "",
                  formatType: "TIME",
                }),
              })
            : t("scheduler_created-by", { name: createdByName })}
        </Typography>
      </Box>
      <Box display="flex">
        <Button color="primary" variant="text" onClick={handleClose}>
          {t("common_cancel")}
        </Button>
        <Button
            color="primary"
            type="submit"
            customStyles={{
              marginLeft: "16px",
            }}
            disabled={
              (
                  Array.isArray(userRolesWithPermissions) && currentUserId?.toString() !== createdBy?.toString()
                      ? !hasPermission(userRolesWithPermissions, "FLEX_SCHEDULER.EDIT_DRAFT_SHIFT")
                      : false
              )
                  ? true
                  : !isValid || !dirty || isSubmitting || isDisabled
            }
        >
          {isSubmitting ? (
              <div style={{ position: "relative" }}>
                <CircularProgress
                    size={25}
                    style={{ position: "absolute", left: "50%" }}
                />{" "}
                {t("scheduler_saving")}
              </div>
          ) : (
              t("scheduler_save-shift")
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default EditActionButtons;
